module.exports = __webpack_public_path__ + "img/anniu1.dcbc3d17.png";